import ProfissionaisPecCnes from '../pages/ProfissionaisPecCnes/ProfissionaisPecCnes';

export default [
    {
        path: '/profissionais-pec-cnes',
        component: ProfissionaisPecCnes 
     }
]